export const CREATE_PROFILE = "CREATE_PROFILE"
export const AUTH = "AUTH"
export const LOAD_USER = "LOAD_USER"
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_SELECTION = "UPDATE_SELECTION"
export const FETCH_INITIAL_HISTORICAL_DATA = "FETCH_INITIAL_HISTORICAL_DATA"
export const GET_QUOTE = "GET_QUOTE"
export const FETCH_INITIAL_QUOTE = "FETCH_INITIAL_QUOTE"
export const GET_HISTORICAL_DATA = "GET_HISTORICAL_DATA"
export const LOGOUT = "LOGOUT"
export const FETCH_TRADES = "FETCH_TRADES"
export const UPDATE_CASH = "UPDATE_CASH"
export const LOAD_AUTH = "LOAD_AUTH"

